import { Grid, ListItem, ListItemButton, ListItemIcon, Tooltip } from "@mui/material";
import { Access } from "../../interfaces/auth.interface";
import { useTheme } from '@mui/material/styles';

import { useSelector } from 'react-redux';
import { RootState } from "../../store";
import menuIcons from './menuIcons';

// import LogoutIcon from '@mui/icons-material/Logout';
// import { logout } from "../../store/slices/auth";

interface UserMenuInterface {
    menuSelected: Access | null;
    onClick: (itemSelected: Access) => void
}

const UserMenu = ({menuSelected, onClick}: UserMenuInterface) => {

    const authState = useSelector((state: RootState) => state.auth);
    // const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();
    // const [menuselected, setMenuselected] = useState<Access | null>();

    return (
        <Grid
          style={{
              width: "3.5rem", 
              backgroundColor: theme.s10palette.S10Blueblue700, 
              height: "100%",
              paddingLeft: ".2rem",
          }}
        >
          {authState.userMenu?.map((group, index) => {
              const MenuIcon = menuIcons[group.Name]
              return (
                <ListItem key={group.Name} disablePadding sx={{ display: 'block' }}>
                  <ListItemButton
                    disableTouchRipple
                    onClick={() => onClick(group)}
                  //     () => {
                  //     setMenuselected(group);
                  //     // setOpen(true)
                  //   }} 
                    sx={{
                        height: "3rem",
                        width: "3.3rem",
                        ...group.Name === menuSelected?.Name 
                            ? {
                                borderLeft:  "2px solid white",
                                borderTopLeftRadius: ".1rem .1rem",
                                borderBottomLeftRadius: ".1rem .1rem",
                                backgroundColor: theme.s10palette.S10Blueblue600,
                                '&:hover': {
                                  backgroundColor: theme.s10palette.S10Blueblue600,
                                },
                            }
                            : {}
                    }}
                  >
                    <Tooltip title={group.Name} placement="right-start">
                      <ListItemIcon style={{minWidth: "0"}}>
                        {MenuIcon ? <MenuIcon 
                          
                          fontSize={"1.5rem"} 
                        /> : "¿?"}
                      </ListItemIcon>
                    </Tooltip>
                  </ListItemButton>
                </ListItem>
              );
          })}
        </Grid>
    )
}

export default UserMenu;